export default __webpack_public_path__ + "static/141-676083183b9581d189874e3d90c4aae0.gif";